import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-scroll-search-police',
  templateUrl: './scroll-search-police.component.html',
  styleUrls: ['./scroll-search-police.component.scss']
})
export class ScrollSearchPoliceComponent implements OnInit {

  items: Array<any> = [];
  user: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  busyGet: Subscription;
  searchKeyPolice: any = "";
  police_id: any
  @Input() souscripteur_id: any;
  @Input() garant_id: any;
  @Input() current_police_id: any;
  @Input() clearText: any;
  @Output() onSelectPolice = new EventEmitter();
  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();

  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('changes: ',changes)
    if (changes.garant_id && changes.garant_id.currentValue) {
      this.garant_id = changes.garant_id.currentValue;
    }
    if (changes.garant_id && changes.garant_id.currentValue) {
      this.garant_id = changes.garant_id.currentValue;
    }

    if (changes.current_police_id && changes.current_police_id.currentValue) {
      this.police_id = changes.current_police_id.currentValue;
    }
    if (changes.clearText && changes.clearText.currentValue) {
      this.clearSelection()
    }
    this.itemsPerPage = 10
    this.getItems()
  }
  onSearch(event) {
    console.log("fkdkfjkd", event);
    this.itemsPerPage = 10;
    this.searchKeyPolice = event.term;
    if (event.term.length)
      this.getItems();
  }

  clearSelection() {
    this.police_id = null; // or undefined
    this.items = []
    this.searchKeyPolice = ''
  }


  onGetMoreItems() {
    this.itemsPerPage += 5;
    this.getItems();
  }


  onSelectElement() {

    this.onSelectPolice.emit(this.police_id)

  }

  getItems() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: this.itemsPerPage,
      search_key: this.searchKeyPolice,
      data: {
        // reseau_de_soin_id: this.reseau_de_soin_id,
        garant_id: this.garant_id,
        souscripteur_id: this.souscripteur_id,
      },
    };

    this.busyGet = this.restClient
      .post("police/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.items = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.items = [];
          }
        },
        (err) => {
          this.items = [];
        }
      );
  }



  onSelectTypePrestataire() { }

  ngOnInit() {
  }

}
